"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */


var _default = {
  inlinemessage: {
    // height: pxToEm(51),
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    // 'flex-start',
    justifyContent: 'space-between',
    margin: (0, _index.replacePXinStringWithEM)("10px 0 0"),
    padding: (0, _index.pxToEm)(17),
    // animation
    transition: 'filter .2s linear 0s',
    // hover
    '&:hover': {
      filter: 'brightness(97%)'
    },
    // ----- alignment ----- //
    '&.align-top-left': {
      boxShadow: _index.theme.boxShadow.small,
      marginBottom: (0, _index.pxToEm)(5),
      animationName: 'fadeInDown'
    },
    '&.align-top-right': {
      boxShadow: _index.theme.boxShadow.small,
      marginBottom: (0, _index.pxToEm)(5),
      animationName: 'fadeInDown'
    },
    '&.align-bottom-left': {
      boxShadow: _index.theme.boxShadow.smallTop,
      marginTop: (0, _index.pxToEm)(5),
      animationName: 'fadeInUp'
    },
    '&.align-bottom-right': {
      boxShadow: _index.theme.boxShadow.smallTop,
      marginTop: (0, _index.pxToEm)(5),
      animationName: 'fadeInUp'
    },
    // ----- details ----- //
    '& .details': {
      display: 'flex',
      alignItems: 'center' // 'flex-start',

    },
    // ----- icon ----- //
    '& .message-icon': {
      marginRight: (0, _index.pxToEm)(8)
    },
    // ----- title ----- //
    '& .title': {
      marginRight: (0, _index.pxToEm)(5)
    },
    // ----- close ----- //
    '& .close': {
      cursor: 'pointer',
      marginLeft: (0, _index.pxToEm)(15),
      transition: 'transform .15s linear 0s',
      '&:hover': {
        transform: 'scale(1.5)'
      }
    },
    // ----- size ----- //
    '&.size-full': {
      width: '100%',
      margin: (0, _index.replacePXinStringWithEM)('0 0 25px')
    },
    // ----- variants ----- //
    '&.variant-primary': {
      background: _index.theme.color.primary.medium.swatch,
      color: _index.theme.color.primary.medium.contrast
    },
    '&.variant-secondary': {
      background: _index.theme.color.secondary.medium.swatch,
      color: _index.theme.color.secondary.medium.contrast
    },
    '&.variant-attention': {
      background: _index.theme.color.attention.dark.swatch,
      color: _index.theme.color.attention.dark.contrast
    },
    '&.variant-warning': {
      background: _index.theme.color.warning.medium.swatch,
      color: _index.theme.color.warning.medium.contrast
    },
    '&.variant-neutral': {
      color: _index.theme.color.supporting.medium.swatch,
      background: _index.theme.color.supporting.light.swatch,
      '& .icon': {
        color: _index.theme.color.neutral.medium.swatch
      }
    },
    // ----- displays ----- //
    '&.display-false': {
      display: 'none'
    }
  }
};
exports.default = _default;